import { useState, useCallback } from 'react';

const useModal = () => {
    const [modalState, setModalState] = useState({ type: null, visible: false });

    const handleOpenModal = useCallback((type) => {
        setModalState({ type, visible: true });
    }, []);

    const handleCloseModal = useCallback(() => {
        setModalState({ type: null, visible: false });
    }, []);

    return {
        modalState,
        handleOpenModal,
        handleCloseModal,
    };
};

export default useModal;